import DialogTitle from './DialogTitle';
export * from './DialogTitle';
export default DialogTitle;